import React from 'react'

import { Button } from '@mui/material'

import './ActionButton.css'

const ActionButton = ({ label, color = 'primary', disabled = false, onClick, ...rest }) => {
    return (<Button {...rest} variant={color === 'secondary' ? 'outlined' : 'contained'} color={color} onClick={onClick} disabled={disabled}>{ label }</Button>)
}

export default ActionButton